import { getQuizTestHandlers } from "./getQuizTestDetails";
import { createReducer } from "../../../core/reduxUtils";

const initialState = {
  currentQuizTest: [],
  quizQuestions: [],
  error: "4444",
  quizTestsList: [],
  quizTestsQuestions: [],
  quizQuestionDetails: {},
  quizTestTakens: [],
  quizTestReports: [],
  quizTestReport: {},
  candidateReportReviewDetails: [],
  quizTestsLeaderboard: [],
  quizTestsCertificates: [],
  quizTestsListLoading: false,
  quizTestReportsLoading: false,
  quizTestDataLoading: false,
  quizQuestionDetailsLoading: false,
  quizTestTakenLoading: false,
  candiateReportReviewDetailsLoading: false,
  deleteLoading: false,
  quizTestSubmittingLoading: false,
  questionCreateLoading: false,
  quizTestLeaderboardLoading: false,
  quizTestCertificatesLoading: false,
  submittingInviteFormLoading: false,
};

const handlers = {
  ...getQuizTestHandlers,
};

const quizTestReducer = createReducer(initialState, handlers);

export default quizTestReducer;
